import React from 'react';

import { Button, Modal, Typography } from 'antd';

import ClipboardField from '../ClipboardField';

interface IProps {
  open: boolean;
  productId?: number;
  product: any;
  url?: any;
  newUrl?: any;
  onClose: any;
}

const ChekoutBooster: React.FC<IProps> = ({ open, onClose, product }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title='Acelerador de Checkout'
      width={640}
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2'>
          <Button type='primary' onClick={onClose}>
            Fechar
          </Button>
        </div>
      }
    >
      <Typography.Paragraph>
        Insira o script abaixo em sua página de vendas para que seja feito o pré carregamento do Checkout, dessa forma
        quando seu cliente clicar em comprar e for redirecionado para o checkout, o mesmo irá carregar bem mais rápido,
        aumentando a possibilidade de conversão.
      </Typography.Paragraph>
      <ClipboardField
        value={`<script>(function(d,c) {var i=c||'preload',u,ifw='PGlmcmFtZSB3aWR0aD0iMCIgaGVpZ2h0PSIwIiBzdHlsZT0icG9zaXRpb246IGFic29sdXRlO3RvcDotMTAwMHB4OyIgc3JjPSJodHRwczovL3N1bi5lZHV6ei5jb20vcGl4ZWwve2lkfSI+PC9pZnJhbWU+';d.write(atob(ifw).replace('{id}',i));})(document,${product.id});</script>`}
      />
    </Modal>
  );
};

export default ChekoutBooster;
